import { omit } from 'lodash'
import { IEvent } from '../../../models/Event'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: { events: IEvent[] },
): IBookingCalendarStore {
  const updatedIds = action.events ? action.events.map(e => e.id) : []

  return {
    ...state,
    eventLabels: omit(state.eventLabels, updatedIds),
  }
}
